import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { BaryModalForm } from '../../../../../../models/bary-modal-form';
import { BaryModalEvent } from '../../../../../../models/bary-modal-event';
import { IMerchandise, Merchandise, MerchandiseControls } from '../../../../../../models/merchandise.model';
import { OfferService } from '../../../../../../services/offer.service';
import { mapAsBody } from '../../../../util/request-util';
import { OfferViewDTO } from '../../../../../../models/offer-view-dto.type';
import { Transporter } from '../../../../../../models/transporter.model';
import { BaryFormFactoryService } from '../../../../../../services/bary-form-factory.service';
import { CurrentDataService } from '../../../../../../services/current-data-service';

@Component({
  selector: 'jhi-modal-add-or-update-merchandise',
  templateUrl: './modal-add-or-update-merchandise.component.html',
})
export class ModalAddOrUpdateMerchandiseComponent extends BaryModalForm implements OnInit {
  override model: IMerchandise = new Merchandise();
  type: 'create' | 'update' = 'create';
  controls?: MerchandiseControls;
  isGlobal?: boolean;
  IOfferViewDTOs: OfferViewDTO[] = [];
  options: Array<{ label: string; value: any }> = [];
  transporter?: Transporter | null;

  constructor(
    private fb: FormBuilder,
    public modalRef: MDBModalRef,
    public bff: BaryFormFactoryService,
    protected offerService: OfferService,
    private currentDataService: CurrentDataService
  ) {
    super();
  }

  ngOnInit(): void {
    this.currentDataService.getCurrentTransporter().subscribe(transporter => (this.transporter = transporter));

    this.offerService
      .getTransporterOffersWithName(this.transporter?.id!)
      .pipe(mapAsBody)
      .subscribe((it: OfferViewDTO[]): void => {
        this.IOfferViewDTOs = it;

        this.IOfferViewDTOs.forEach((offer: OfferViewDTO): void => {
          const optionTemp: { label: string; value: any } = { label: offer.name!, value: offer };
          this.options.push(optionTemp);
        });
      });

    this.controls = this.bff.makeMerchandiseControls(this.model);
    if (this.isGlobal) {
      this.controls.newName.disable();
    }
    this.modalForm = this.fb.group(this.controls);
  }

  handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.modalRef.hide();
  }

  changeActif($event: any): void {
    this.model.forceQuotation = !!$event;
  }

  override handleSubmit(): void {
    if (this.modalForm.invalid) {
      this.modalForm.markAllAsTouched();
      this.focusOnFirstError();
    } else {
      this.model.newName = this.controls?.newName.value;
      this.model.offers = this.controls?.offers.value;
      this.action.next(new BaryModalEvent({ submit: true, value: this.model }));
      this.modalRef.hide();
    }
  }
}
